import Icon from '../components/Icon.vue'

Icon.register({
  snowplow: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M120 376c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM200 376c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM280 376c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM360 376c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM598.6 425.4l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6l-22.6 22.6c-6.2 6.2-16.4 6.2-22.6 0l-36.7-36.7c-26.5-26.5-41.4-62.4-41.4-99.9v-18.7h-43.2c7 14.6 11.2 30.7 11.2 48 0 61.9-50.1 112-112 112h-256c-61.9 0-112-50.1-112-112 0-44.6 26.3-82.8 64-100.8v-91.2c0-26.5 21.5-48 48-48h16v-112c0-26.5 21.5-48 48-48h144.3c19.3 0 36.6 11.4 44.2 29.1l78.3 182.8c3.4 8 5.2 16.5 5.2 25.2v50.9h64v-18.7c0-37.5 14.9-73.4 41.4-99.9l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0l22.6 22.6c6.2 6.2 6.2 16.4 0 22.6l-36.7 36.7c-14.5 14.5-22.6 34.1-22.6 54.6v101.6c0 20.5 8.1 40.1 22.6 54.6zM192 64v96l64 64h122.4l-68.6-160h-117.8zM368 448c26.5 0 48-21.5 48-48s-21.5-48-48-48h-256c-26.5 0-48 21.5-48 48s21.5 48 48 48h256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/snowplow.js
// module id = 1913
// module chunks = 0